import UAParser from 'ua-parser-js';
import { useAuthStore } from '@/store';
import { isArray, isString } from '@/utils';

/** 获取设备信息 */
export function useDeviceInfo() {
  const parser = new UAParser();
  const result = parser.getResult();
  return result;
}

/** 权限判断 */
export function usePermission() {
  const auth = useAuthStore();

  function hasPermission(permission: string | string[]) {
    if (auth.perms.includes('admin')) {
      return true;
    }
    let has = false;
    if (isArray(permission)) {
      has = permission.some(item => auth.perms.includes(item));
    }
    if (isString(permission)) {
      has = auth.perms.includes(permission);
    }
    return has;
  }

  return {
    hasPermission
  };
}
